import api from '..';
import core from '@/core';

function getRequest(data) {
  const request = {};
  Object.keys(data)
    .forEach((key) => {
      const item = data[key];
      const type = typeof item;
      if (type === 'string' || type === 'number' || type === 'boolean') {
        request[key] = data[key];
      } else if (item?.getTime()) {
        request[key] = {
          Serialized: core.utils.date.toString(item),
          Format: 'dd.MM.yyyy',
        };
      } else if (item?.value) {
        request[`${key}Id`] = item.value;
      }
    });
  return request;
}

export default ({ name, model }) => api
  .post(
    `/tourclient/masteragent/dictionary/${name}/insert`,
    `request=${encodeURIComponent(JSON.stringify(getRequest(model)))}`,
    { formatting: true },
  )
  .then(data => api.store
    .delGroup(`dictionary/${name}`)
    .then(() => data));
